<template>
  <el-card class="mt-4" shadow="never">
    <div class="ver-title">{{ $str.getKey('设备升级/eLink版本信息') }}</div>
    <el-table :data="eLinkTableData" :row-style="getELinkRowStyle" v-loading="loading">
      <el-table-column label="UUID" prop="uuid"></el-table-column>
      <el-table-column :label="$str.getKey('设备升级/序列号')" prop="dev_id"></el-table-column>
      <el-table-column :label="$str.getKey('设备升级/版本信息')">
        <el-table-column label="sver_app" prop="sver_app"></el-table-column>
        <el-table-column label="sver_fs" prop="sver_fs"></el-table-column>
        <el-table-column label="sver_kernel" prop="sver_kernel"></el-table-column>
        <el-table-column label="sver_dtree" prop="sver_dtree"></el-table-column>
      </el-table-column>
    </el-table>

    <div class="ver-title">{{ $str.getKey('设备升级/eBlock版本信息') }}</div>
    <el-table :data="eBlockTableData" :span-method="objectSpanMethod" v-loading="loading" class="ver-table">
      <el-table-column label="eLinkUUID" prop="elk_order" fixed="left"></el-table-column>
      <el-table-column label="eBlockUUID" prop="eb_order"></el-table-column>
      <el-table-column label="BCS">
        <el-table-column label="APP" prop="bcs_sver_app"></el-table-column>
        <el-table-column label="BOOT" prop="bcs_sver_boot"></el-table-column>
      </el-table-column>
      <el-table-column label="BMU">
        <el-table-column :label="$str.getKey('设备升级/序号')" prop="bmu_order"></el-table-column>
        <el-table-column label="APP" prop="bmu_sver_app"></el-table-column>
        <el-table-column label="BOOT" prop="bmu_sver_boot"></el-table-column>
      </el-table-column>

      <el-table-column :label="`PCS${i}`" v-for="i in pcsLength" :key="i">
        <el-table-column :label="`APP1`" :prop="`pcs${i}_sver_app_cpu1`"></el-table-column>
        <el-table-column :label="`APP2`" :prop="`pcs${i}_sver_app_cpu2`"></el-table-column>
        <el-table-column :label="`BOOT1`" :prop="`pcs${i}_sver_boot_cpu1`"></el-table-column>
        <el-table-column :label="`BOOT2`" :prop="`pcs${i}_sver_boot_cpu2`"></el-table-column>
        <el-table-column label="FPGA" :prop="`pcs${i}_sver_fpga`"></el-table-column>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script setup>
import { computed, ref, watchEffect } from 'vue'
import { versionList } from "@/api/upgrade"
import { createMergeRows, groupDifferenceVersions } from './feature'

const props = defineProps(['stationId'])
const eLinkTableData = ref([])
const eBlockTableData = ref([])

const loading = ref(false)
const verList = ref([])

const $str = window.$str
watchEffect(async () => {
  if (props.stationId != null && props.stationId !== '') {
    loading.value = true
    try {
      const res = await versionList(props.stationId)
      const dt = res.data
      verList.value = dt
      eLinkTableData.value = handlereLinkVersionData(dt)
      eBlockTableData.value = handlereBlockVersionData(dt)
    } catch (error) {
      console.warn(error)
    } finally {
      loading.value = false
    }
  }
})

const pcsLength = computed(() => {
  const eLinkData = verList.value[0]
  if (!eLinkData) {
    return 1
  }
  const eBlockData = eLinkData?.eBlocks?.[0]
  if (!eBlockData) {
    return 1
  }
  return eBlockData.pcs.length
})

function handlereLinkVersionData(verList) {
  const table = []
  const compareKeys = ['sver_app', 'sver_fs', 'sver_kernel', 'sver_dtree']
  const group = groupDifferenceVersions(verList, compareKeys)
  for (const [_, list] of group) {
    table.push(...list)
  }
  table.$groupSize = group.size

  return table
}

function handlereBlockVersionData(verList) {
  const table = []
  for (let elk_idx = 0; elk_idx < verList.length; elk_idx++) {
    const eLinkData = verList[elk_idx]

    for (let eb_idx = 0; eb_idx < eLinkData.eBlocks.length; eb_idx++) {
      const eBlockData = eLinkData.eBlocks[eb_idx]
      const bmuGroup = groupDifferenceVersions(eBlockData.bmu, ['sver_app', 'sver_boot'])

      for (const [_, list] of bmuGroup) {
        let indexList = list.map(it => it.sort)
        if (indexList.length === eBlockData.bmu.length) {
          indexList = `1~${eBlockData.bmu.length}`
        } else {
          indexList = indexList.join(',')
        }

        const pcsObj = {}
        eBlockData.pcs.map((p, i) => {
          let no = i + 1
          pcsObj[`pcs${no}_sver_app_cpu1`] = p.sver_app_cpu1
          pcsObj[`pcs${no}_sver_app_cpu2`] = p.sver_app_cpu2
          pcsObj[`pcs${no}_sver_boot_cpu1`] = p.sver_boot_cpu1
          pcsObj[`pcs${no}_sver_boot_cpu2`] = p.sver_boot_cpu2
          pcsObj[`pcs${no}_sver_fpga`] = p.sver_fpga
        })

        const tableItem = {
          elk_order: eLinkData.uuid,
          eb_order: eBlockData.uuid,
          bcs_sver_app: eBlockData.bcs.sver_app,
          bcs_sver_boot: eBlockData.bcs.sver_boot,
          bmu_order: indexList,
          bmu_sver_app: list[0].sver_app,
          bmu_sver_boot: list[0].sver_boot,
          ...pcsObj,
        }

        table.push(tableItem)
      }
    }
  }

  return table
}

const mergeRows = createMergeRows(eBlockTableData, 'elk_order')
const Spanindexs = createMergeRows(eBlockTableData, 'eb_order')

function objectSpanMethod({ columnIndex, rowIndex }) {
  if (columnIndex === 0) {
    const _row = mergeRows.value[rowIndex]
    const _col = _row > 0 ? 1 : 0
    return {
      rowspan: _row,
      colspan: _col
    }
  }
  const colIndexs = [1, 2, 3, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]
  if (colIndexs.includes(columnIndex)) {
    const _row = Spanindexs.value[rowIndex]
    const _col = _row > 0 ? 1 : 0
    return {
      rowspan: _row,
      colspan: _col
    }
  }
}

function getELinkRowStyle({ row }) {
  return {
    color: eLinkTableData.value.$groupSize > 1 ? row.$color : 'inherit'
  }
}
</script>

<style lang='scss' src="./style.scss"></style>
